export default __webpack_public_path__ + "static/contact-mobile-6f2065bbed354eebdd8e727b9259eeae.png";